/**
 * 送信件数を数えている請求期間（契約日基準）の表示。
 *
 * サーバーは Stripe の請求期間を usagePeriodStart / usagePeriodEnd で返す（GET /tenants/me）。
 * 終わり（usagePeriodEnd）は次の期間の開始と同じ時刻なので、表示する最終日はその前日。
 * 契約が無い（無料トライアル・社内テナント）・期間が未記録のときは null。
 */
export interface UsagePeriodLabel {
  /** 例: "10/16〜11/15" */
  range: string;
  /** 送信件数が 0 に戻る日。例: "11/16" */
  nextReset: string;
}

const md = (d: Date) =>
  d.toLocaleDateString("ja-JP", { timeZone: "Asia/Tokyo", month: "numeric", day: "numeric" });

export function usagePeriodLabel(tenant: { usagePeriodStart?: string | null; usagePeriodEnd?: string | null } | null | undefined): UsagePeriodLabel | null {
  if (!tenant?.usagePeriodStart || !tenant?.usagePeriodEnd) return null;
  const start = new Date(tenant.usagePeriodStart);
  const end = new Date(tenant.usagePeriodEnd);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) return null;
  // 最終日はリセット日の前日（日本時間）。end の 1 ミリ秒前だと、日をまたいだ直後に終わる期間で
  // 「〜11/16」と「次のリセット 11/16」が重なるため、24 時間前の日付にする（日本時間に夏時間は無い）
  const lastDay = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  return { range: `${md(start)}〜${md(lastDay)}`, nextReset: md(end) };
}
